import en from "lang/en.json";
import es from "lang/es.json";
import Head from "next/head";
import React from "react";
import AgencyProfileContain, {
  IAgencyProfileContain,
} from "@components-pages/profiles/agency-profile";
import { getAgency } from "api/agencies.request";
import { IAgencyResponse } from "shared/models/interfaces/response/agency.interface";
import { useRouter } from "next/router";

import type { GetServerSideProps } from "next";
import { useSessionStorage } from "usehooks-ts";
import createCanonicalUrl from "@helpers/removeparams";
interface IAgencyProfilePage {
  id: number;
  data: IAgencyResponse;
}

const Agencia = (props: IAgencyProfilePage) => {
  const [code, setCode] = useSessionStorage<{ id: any; type: any }>("code", {
    id: null,
    type: null,
  });

  const router = useRouter();
  const configProfile: IAgencyProfileContain = {
    id: props.id,
    data: props.data,
  };

  const metaData = {
    description: `Agencia inmobiliaria ${props.data.data.name} Código ${props.id}`,
    keyWords:
      "Agencia inmobiliaria, Agencia inmobiliaria remax rd, Agencia Remax, Remax agencia inmobiliaria, Agencia Remax República Dominicana",
    url: process.env.NEXT_PUBLIC_DOMAIN_URL + router.asPath,
    type: `Agencia RE/MAX ${props.data.data.name}`,
    title: `Agencia ${props.data.data.name.toUpperCase()} `,
  };

  React.useEffect(() => {
    setCode({ id: props.id, type: "areferer" });
    router.push(router.asPath, undefined, { shallow: true });
  }, []);

  return (
    <>
      <Head>
        <title>{metaData.title}</title>
        <meta name="description" content={metaData.description} />
        <meta property="og:url" content={metaData.url} />
        <meta property="og:type" content={metaData.type} />
        <meta property="og:title" content={metaData.title} />
        <meta property="og:image" content={props.data.data.picture} />
        <meta name="keywords" content={metaData.keyWords} />
        <link rel="canonical" href={createCanonicalUrl(metaData.url)} key="canonical" />
      </Head>
      <AgencyProfileContain {...configProfile} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  /* @ts-ignore */
  const params = context.params as any;
  const id = params.params[1];
  const data = await getAgency(id);

  if (data.status === 404 || data.status === 500) {
    return {
      redirect: {
        destination: "/listado/agencias",
        permanent: false,
      },
    };
  }

  return {
    props: {
      id: params.params[1],
      messages: context.locale === "es" ? es : en,
      url: context.resolvedUrl,
      data: data,
    },
  };
};

export default Agencia;
